/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfbreq13Inputs */

const en_crosspostinghelpfbreq13 = /** @type {(inputs: Crosspostinghelpfbreq13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need a Facebook Page (a business page), not just a personal profile.`)
};

const de_crosspostinghelpfbreq13 = /** @type {(inputs: Crosspostinghelpfbreq13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du brauchst eine Facebook-Seite (Unternehmensseite), nicht nur ein privates Profil.`)
};

/**
* | output |
* | --- |
* | "You need a Facebook Page (a business page), not just a personal profile." |
*
* @param {Crosspostinghelpfbreq13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfbreq13 = /** @type {((inputs?: Crosspostinghelpfbreq13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfbreq13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfbreq13(inputs)
	return de_crosspostinghelpfbreq13(inputs)
});
export { crosspostinghelpfbreq13 as "crosspostingHelpFbReq1" }